var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel text-center"},[_c('coupons-route',{attrs:{"offer":_vm.offerData,"coupons":_vm.offerData.coupons}})],1),_c('div',{staticClass:"copyright pt-2"},[_vm._v(" "+_vm._s(_vm.$t('coupon.copyright'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }